import { jwtDecode } from "jwt-decode";

export const getToken = () => localStorage.getItem("token");

export const decodeToken = (token) => {
  try {
    return jwtDecode(token);
  } catch (e) {
    return null;
  }
};

export const getUserFromToken = () => {
  const token = getToken();
  if (!token) return null;

  const decoded = jwtDecode(token);

  if (!decoded) return null;

  const { id, email, sub: name, role, exp } = decoded;

  // Optional: logout if expired
  const isExpired = exp * 1000 < Date.now();
  if (isExpired) return null;

  return { id, email, name, role };
};
